// extracted by mini-css-extract-plugin
export var flexcontainer = "ways-to-order-module--flexcontainer--pAdxB";
export var thirdcol = "ways-to-order-module--thirdcol--SRng1";